import React, {useState, useRef, useEffect, memo} from 'react';
import AWS from "aws-sdk";

import * as ReactUtils from "../utils/ReactUtils.js";
import * as Utils from '../utils/Utils.js';
import * as HttpRequestUtils from '../utils/HttpRequestUtils';

import rocketloadingImage from "../images/rocket.gif";

const ChatPDF = ({ isUserSignedIn, isUserSubscribed }) => {
  useEffect(() => {
    document.getElementById('fileInput').addEventListener('change', function(event) {
      const file = event.target.files[0];
      const preview = document.getElementById('preview');

      // Clear previous content
      preview.innerHTML = '';

      if (!file) {
          return;
      }

      if (file.type === 'application/pdf') {
          // Preview PDF
          const embed = document.createElement('embed');
          embed.src = URL.createObjectURL(file);
          embed.type = 'application/pdf';
          embed.style.width = '500px';
          embed.style.height = '600px';
          preview.appendChild(embed);
      } else if (file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          // For DOC files, since we can't directly preview them in the browser, provide a link to download/view. There are a couple of mitigations 
          // if we really need preview this in the future
          // https://jstool.gitlab.io/demo/preview-ms-word-docx-document-in-browser/
          // https://stackoverflow.com/questions/27957766/how-do-i-render-a-word-document-doc-docx-in-the-browser-using-javascript
          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.textContent = 'Download and view the DOC file';
          link.download = file.name; // Suggest a download filename
          preview.appendChild(link); 
      } else {
          preview.textContent = 'Unsupported file type';
      }
    });
  }, []);

  return (
    <div>
      <input type="file" id="fileInput" accept=".pdf,.doc,.docx"/>
      <div id="preview"></div>
    </div>
  )
}

export default ChatPDF;  